<script>
  import _ from 'lodash'
  import TextCounter from './text-counter'
  import ThemeQuestionAnswerField from '../components/theme-question-answer-field'

  export default {
    template: `<div><slot v-bind="self"/></div>`,
    name: 'ThemeQuestionAnswerFieldForProfit',
    mixins: [ThemeQuestionAnswerField],
    components: {
      'text-counter': TextCounter
    },
  }
</script>
